<template>
  <div>
    <v-select
      name="category"
      placeholder="Select a product or service"
      :options="categories"
      v-model="data.category"
      @input="handleMakeBookingClick"
    ></v-select>
  </div>
</template>

<script>
import axios from "@/helpers/axios";

export default {
  name: "NewBookingCategory",
  components: {},
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    categories: [],
    data: {
      category: null
    }
  }),
  created() {
    this.init();
  },
  methods: {
    handleMakeBookingClick(category) {
      if (this.data.category) {
        this.$router.push({
          name: "new-booking",
          params: {
            id: this.singleRecord.id,
            categoryId: category.value,
            label: category.label
          }
        });
        this.$emit("close");
      }
    },
    init() {
      this.paginated("categories");
    },
    paginated(collection, action = "", page = 1) {
      axios
        .get(`/${collection}?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          var { data, meta } = response.data;
          data = data.map(product => ({
            label: product.name,
            value: product.id
          }));
          this[collection] = [...this[collection], ...data];
          if (meta.hasNextPage) {
            this.paginated(collection, action, page + 1);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
